export interface MenuItem {
  label: string;
  path?: string;
  icon?: string;
  children?: MenuItem[];
  key?: string;
}

interface ModuleMeta {
  labelKey: string;
  icon?: string;
  key: string;
}

interface ItemMeta {
  labelKey: string;
  path: string;
  icon?: string;
}

const normalize = (s: string): string =>
  s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[\s\-_]+/g, '');

export const HOME_ITEM: MenuItem = {
  label: 'SIDEBAR.HOME',
  path: '/home',
  icon: 'home',
  key: 'home',
};

const MODULE_META: Record<string, ModuleMeta> = {
  cadastro: { labelKey: 'SIDEBAR.CADASTRO', key: 'cadastro' },
  clientes: { labelKey: 'SIDEBAR.CLIENTS', key: 'clients' },
  admin: { labelKey: 'SIDEBAR.ADM', key: 'admin' },
};

const ITEM_META: Record<string, ItemMeta> = {
  assessores: { labelKey: 'SIDEBAR.ASSESSORES', path: '/cadastro/assessores', icon: 'group' },
  investidores: { labelKey: 'SIDEBAR.INVESTIDORES', path: '/cadastro/investidores', icon: 'group' },
  backoffice: { labelKey: 'SIDEBAR.BACK_OFFICE', path: '/cadastro/back-office', icon: 'admin_panel_settings' },

  permissoes: { labelKey: 'SIDEBAR.PERMISSOES', path: '/adm/permissoes', icon: 'lock_open' },
  // Usuários migrou de /cadastro para o módulo de administração.
  usuarios: { labelKey: 'SIDEBAR.USUARIOS', path: '/adm/usuarios', icon: 'person' },

  visaogeral: { labelKey: 'SIDEBAR.OVERVIEW', path: '/clients/overview', icon: 'visibility' },
  saldobancario: { labelKey: 'SIDEBAR.BANK_BALANCE', path: '/clients/bank-balance', icon: 'account_balance' },
  investir: { labelKey: 'SIDEBAR.INVEST', path: '/clients/invest', icon: 'trending_up' },
  extrato: { labelKey: 'SIDEBAR.EXTRACT', path: '/clients/statement', icon: 'receipt_long' },
  dadosgerais: { labelKey: 'SIDEBAR.GENERAL_DATA', path: '/clients/client-data', icon: 'badge' },
};

export function buildMenuItems(menu: Record<string, string[]>): MenuItem[] {
  const items: MenuItem[] = [HOME_ITEM];

  for (const [moduleName, children] of Object.entries(menu ?? {})) {
    const moduleMeta = MODULE_META[normalize(moduleName)];
    if (!moduleMeta) continue;

    const mappedChildren: MenuItem[] = (children ?? []).flatMap(name => {
      const meta = ITEM_META[normalize(name)];
      return meta ? [{ label: meta.labelKey, path: meta.path, icon: meta.icon }] : [];
    });

    if (mappedChildren.length === 0) continue;

    items.push({
      label: moduleMeta.labelKey,
      key: moduleMeta.key,
      children: mappedChildren,
    });
  }

  return items;
}
